var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37983 13.7803C5.08693 13.4874 5.08693 13.0126 5.37983 12.7197L10.0995 8L5.37983 3.28033C5.08693 2.98744 5.08693 2.51256 5.37983 2.21967C5.67272 1.92678 6.14759 1.92678 6.44049 2.21967L11.6905 7.46967C11.9834 7.76256 11.9834 8.23744 11.6905 8.53033L6.44049 13.7803C6.14759 14.0732 5.67272 14.0732 5.37983 13.7803Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.bb71a811799d09192f28a5a43c4be4dd.svg";
export { ForwardRef as ReactComponent };